"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scrollbars = void 0;
var Scrollbars_1 = __importDefault(require("./Scrollbars"));
exports.Scrollbars = Scrollbars_1.default;
exports.default = Scrollbars_1.default;
